 document.addEventListener("DOMContentLoaded", function () {
  const accordionTitles = document.querySelectorAll(".accordion-title");

  accordionTitles.forEach((title) => {
    title.addEventListener("click", function () {
      this.classList.toggle("active");
      const content = this.nextElementSibling; // Get the associated content
      content.classList.toggle("active");
    });
  });
});